import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { HOME } from "@/constants/testIds";

const PROGRAMS = [
  {
    n: "01",
    slug: "ascent",
    title: "Ascent",
    duration: "12 Weeks",
    focus: "Hypertrophy · Zone 2",
    body: "A gradient of load and stillness. Wake the fascia. Rebuild the tendons. Find the shape.",
  },
  {
    n: "02",
    slug: "altitude",
    title: "Altitude",
    duration: "8 Weeks",
    focus: "VO₂ · Breathwork",
    body: "Engineered for high-output athletes. Thin the air in your own lungs. Widen the ceiling.",
  },
  {
    n: "03",
    slug: "stillness",
    title: "Stillness",
    duration: "Perennial",
    focus: "Mobility · Meditation",
    body: "The counterweight. Twenty minutes of dawn before the world remembers you exist.",
  },
  {
    n: "04",
    slug: "iron-order",
    title: "Iron Order",
    duration: "16 Weeks",
    focus: "Strength · Power",
    body: "A slow, brutal accumulation. Barbell only. No music. Signed by the numbered.",
  },
];

export const Programs = () => {
  return (
    <section
      id="programs"
      data-testid={HOME.programs}
      className="relative bg-black text-white py-32 md:py-44"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="grid grid-cols-12 gap-6 mb-16 md:mb-24 border-b border-white/10 pb-10"
        >
          <div className="col-span-12 md:col-span-7">
            <div className="font-mono text-[10px] tracking-[0.42em] text-silver-300 mb-3">
              §03 — PROGRAMS
            </div>
            <h2 className="font-serif text-[10vw] md:text-[5vw] leading-[0.95] tracking-[-0.02em] text-white">
              Four ways to
              <br />
              <span className="italic text-silver-100">become quieter.</span>
            </h2>
          </div>
          <p className="col-span-12 md:col-span-4 md:col-start-9 self-end text-white/60 text-[14px] leading-[1.75]">
            Delivered as a weekly dispatch. Written by a rotating council of
            climbers, olympians, and monks. Progress is not a bar. It is a
            posture you carry into the room.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/8">
          {PROGRAMS.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.7,
                delay: (i % 2) * 0.08,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              <Link
                to={`/programs/${p.slug}`}
                data-testid={`${HOME.programCard}-${p.slug}`}
                className="group relative block bg-black p-10 md:p-14 min-h-[340px] flex flex-col justify-between overflow-hidden"
              >
                {/* Sweep on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-white/[0.04] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                <div className="absolute -inset-x-10 -top-10 h-px bg-silver-100/60 opacity-0 group-hover:opacity-100 group-hover:translate-y-4 transition-all duration-700" />

                <div className="relative flex items-start justify-between">
                  <div className="font-mono text-silver-200 text-[11px] tracking-[0.42em]">
                    N° {p.n}
                  </div>
                  <div className="text-right font-mono text-[10px] tracking-[0.32em] text-white/40">
                    {p.duration}
                  </div>
                </div>

                <div className="relative">
                  <h3 className="font-serif text-[13vw] md:text-[5vw] leading-[0.9] tracking-[-0.02em] text-white group-hover:text-silver-100 transition-colors duration-500">
                    {p.title}
                  </h3>
                  <div className="mt-6 flex items-center gap-4">
                    <span className="text-white/70 text-[13px] tracking-[0.14em] uppercase">
                      {p.focus}
                    </span>
                  </div>
                  <p className="mt-6 text-white/55 text-[14px] leading-[1.75] max-w-md">
                    {p.body}
                  </p>
                </div>

                <div className="relative flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase text-silver-100">
                  <span>Enroll</span>
                  <span className="w-8 h-px bg-silver-100 group-hover:w-16 transition-all duration-500" />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Programs;
